import type { TableRow } from '../../../../stores/table-store';
import { buildPanelCellCommitUpdate } from '../../expanded-cell-view/panel-cell-updates';
import { type DraftField, draftFieldCommitText } from './action-assist-model';

/**
 * The row update Apply writes: only the KEPT fields, each converted exactly
 * as the node panel's own editor would commit it on blur
 * (`buildPanelCellCommitUpdate`), so an applied draft is indistinguishable
 * from the same values typed by hand. `isJsonColumn` is the store's own
 * check, passed in so this stays testable without the store.
 */
export const buildDraftApplyUpdates = (
  fields: DraftField[],
  keep: Record<string, boolean>,
  isJsonColumn: (column: string) => boolean
): Partial<TableRow> => {
  const updates: Partial<TableRow> = {};
  fields
    .filter((f) => keep[f.column])
    .forEach((f) => {
      Object.assign(
        updates,
        buildPanelCellCommitUpdate(
          f.column,
          draftFieldCommitText(f),
          isJsonColumn(f.column)
        )
      );
    });
  return updates;
};
